export default "__VITE_ASSET__e79834ce__"